<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <BandejaComponenteV5
        :aplicaBusquedaFecha="false"
        :codigoTitulo="codigoTitulo"
        :subTitulo="subTitulo"
        :cifrasControl="cifrasControl"
        :datosTabla="datosTabla"
        :resource="resource"
        :nombreTab="nombreTab"
        @_funcionExtra="getObtenerDatosBandeja"
        @_funcionExtra2="abrirModalObservaciones"
        @_funcionExtra3="abrirModalObservacionesRechazo"
        @_funcionExtra4="abrirModalRechazar"
        @_actualizaFecha="actualizarFecha"
    >
      <template slot="loader">
        <b-alert
            v-if="datosTabla.length === 0 && !loader"
            show>No hay datos
        </b-alert>
        <b-spinner v-if="loader"></b-spinner>
      </template>
    </BandejaComponenteV5>

    <!-- Modal de observaciones-->

    <b-modal
        ref="observaciones"
        title="Observaciones Diagnóstico"
        hide-footer
    >
      <br/>
      <h4 v-if="solicitud !== null" class="my-4 text-left">{{ solicitud.observacionesDiagnostico }}</h4>
      <br/>
      <b-button
          class="mt-3"
          variant="outline-info"
          block
          @click="cerrarModal('observaciones')"
      >Cerrar
      </b-button
      >
      <br/><br/>
    </b-modal>

    <!-- Modal de observaciones rechazo    -->

    <b-modal
        ref="observacionesRechazo"
        title="Observaciones de Rechazo"
        hide-footer
    >
      <br/>
      <h4 v-if="solicitud !== null" class="my-4 text-left">{{ solicitud.motivoRechazo }}</h4>
      <br/>
      <b-button
          class="mt-3"
          variant="outline-info"
          block
          @click="cerrarModal('observacionesRechazo')"
      >Cerrar
      </b-button
      >
      <br/><br/>
    </b-modal>

    <!--  Modal para rechazar PTI  -->

    <b-modal
        ref="rechazo"
        title="Rechazar PTI"
        hide-footer
    >
      <validation-observer ref="observer" v-slot="{ handleSubmit }" v-if="solicitud !== null">
        <b-form
            @submit.stop.prevent="
            handleSubmit(
              postRechazarPTIPresuntivo(solicitud.idSolicitudDiagnostico)
            )
          "
        >
          <validation-provider
              :name="'validacion' + solicitud.idSolicitudDiagnostico"
              :rules="{ required: true }"
              v-slot="motivoSlot"
          >
            <b-form-textarea
                v-model="motivoRechazo"
                placeholder="Motivo Rechazo del PTI"
                :state="
                motivoSlot.errors[0] ? false : motivoSlot.valid ? true : null
              "
                rows="2"
                max-rows="6"
            ></b-form-textarea>

            <validacion
                :texto="motivoSlot.errors[0] ? motivoSlot.errors[0] : ''"
            ></validacion>
          </validation-provider>

          <br/><br/>
          <b-button variant="outline-success" type="submit" block
          >Guardar
          </b-button
          >
          <b-button
              class="mt-3"
              variant="outline-primary"
              block
              @click="cerrarModal('rechazo')"
          >Cerrar
          </b-button
          >
        </b-form>
      </validation-observer>

      <br/><br/>
    </b-modal>

  </div>
</template>

<script>
import Swal from "sweetalert2";
import BandejaComponenteV5 from "@/version5/bandejas/BandejaComponenteV5.vue";

export default {
  name: "BandejaEmbajadorHallazgoV5",
  components: {BandejaComponenteV5},
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loader: false,
    fechaFin: "",
    fechaIncio: "",
    idEmpleado: null,
    idClinica: null,
    idUsuario: null,
    idPaciente: 0,
    datosTabla: [],
    encabezadosNegociar: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "idPaciente",
        label: "ID paciente",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacientePTIPresuntivoComponente",
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      },
      {
        key: "dteFechaSesion",
        label: "Inicio de sesión",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dteFechaHerramienta",
        label: "Herramientas",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dtehoraInicio",
        label: "CDX inicia PTI",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "intIdNivelPTI",
        label: "Nivel PTI",
        sortable: true
      },
      {
        key: "fechaEntradaEtapa",
        label: "Reingreso a UP",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "nombreEmbajador",
        label: "Presentador PTI Presuntivo",
        sortable: true,
        component: "BandejaEmbajadorComponente",
      },
      {
        key: "observacionesDiagnostico",
        label: "Observaciones Diagnóstico",
        sortable: true,
        component: "BandejaObservacionesDiagnostico",
      },
    ],
    encabezadosInversion: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacientePTIPresuntivoComponente",
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      },
      {
        key: "dteFechaSesion",
        label: "Inicio de sesión",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dteFechaHerramienta",
        label: "Herramientas",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "fechaEntradaEtapa",
        label: "Reingreso a UP",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "nombreEmbajador",
        label: "Presentador PTI Presuntivo",
        sortable: true,
        component: "BandejaEmbajadorComponente",
      },
      {
        key: "observacionesDiagnostico",
        label: "Observaciones Diagnóstico",
        sortable: true,
        component: "BandejaObservacionesDiagnostico",
      },
    ],
    encabezadosDistribucion: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacientePTIPresuntivoComponente",
      },
      {
        key: "nombreSolcitante",
        label: "Doctor solicitante",
        sortable: true,
      },
      {
        key: "dteFechaSesion",
        label: "Inicio de sesión",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "dteFechaHerramienta",
        label: "Herramientas",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "fechaEntradaEtapa",
        label: "Reingreso a UP",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "nombreEmbajador",
        label: "Presentador PTI Presuntivo",
        sortable: true,
        component: "BandejaEmbajadorComponente",
      },
      {
        key: "observacionesDiagnostico",
        label: "Observaciones Diagnóstico",
        sortable: true,
        component: "BandejaObservacionesDiagnostico",
      },
    ],

    cifrasControl: [
      {
        id: 1,
        nombre: "Negociar",
        identificadorTab:"negociar",
        visible: false,
        layoutTabla: [],
        // permiso: "UP_Revisar_PTI"
      },
      {
        id: 2,
        nombre: "Inversión",
        identificadorTab:"inversion",
        visible: false,
        layoutTabla: [],
        // permiso: "UP_Presentar_PTI"
      },
      {
        id: 3,
        nombre: "Distribución",
        identificadorTab: "distribucion",
        visible: false,
        layoutTabla: [],
        // permiso: 'UP_Inversion_PTI'
      },
    ],
    codigoTitulo: "BJ_01_HallazgoEE",
    subTitulo: "Unidad de Presentación",
    resource: {
      permiteCambiarDiagnosticador: null,
      idEstatusSolicitud: null,
      arrayDoctorEmbajador: [],
      proceso: null
    },
    idEstatusPestaniaSeleccionada: 1,
    // idEstatusSubTabSeleccionada: 0,
    solicitud: null,
    motivoRechazo: null,
    loading: false,
    nombreTab: "",
  }),
  methods: {
    // getObtenerDatosBandeja(intIdEstuatusSolicitud, idSubtab) {
    getObtenerDatosBandeja(intIdEstuatusSolicitud) {

      this.loader = true

      this.datosTabla = [];

      this.idEstatusPestaniaSeleccionada = intIdEstuatusSolicitud;
      // this.idEstatusSubTabSeleccionada = idSubtab;

      var url = this.$api +
          "pti/bandeja/embajador/obtenerDatosGlobalBandejav5"

      this.$http
          .post(url, this.datos())
          .then((response) => {
            //NO devuelve un array asi que no funciona validar isArray
            this.resource.permiteCambiarDiagnosticador = response.data.data.blnPermiteEditar;
            this.resource.idEstatusSolicitud = intIdEstuatusSolicitud;

            //EL COMPONENTE!!!!!!!!!!!!!!
            if (this.idEstatusPestaniaSeleccionada === 1) {
              this.resource.proceso = 'presentacion_m2';
            } else {
              this.resource.proceso = 'unidadPresentacion';
            }

            this.datosTabla = response.data.data.listaResultados;
            if (response.data.data.listaResultados.length === 0) {
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: response.data.message,
              });
            } else {
              Swal.close();
              /* this.getCifrasPorEstatus();*/
            }

          })
          .catch((error) => {
            console.error(error);
            Swal.close();
          }).finally(() => {
        this.loader = false
        this.getCifrasPorEstatus();
      });

    },
    datos() {
      const envio = {
        fechaFinal: this.fechaFin,
        fechaIncio: this.fechaInicio,
        idEmpleado: this.idEmpleado,
        idClinica: this.idClinica,
        idPaciente: this.idPaciente,
        idEtapa: null,
        idEstatusEmbajador: null,
        idEstatus: null
      }

      switch (this.idEstatusPestaniaSeleccionada) {
        case 1 : {
          envio.idEtapa = 89;
          envio.idEstatus = [1,2];
          break;
        }
        case 2:{
          envio.idEtapa = 90;
          envio.idEstatus = [1,2];
          break
        }
        case 3 : {
          envio.idEtapa = 91;
          envio.idEstatus = [1,2];
          break;
        }

      }
      /*switch (this.idEstatusSubTabSeleccionada) {
        case 1 : {
          envio.idEstatus = [1];
          break;
        }
        case 2:{
          envio.idEstatus = [2];
          break
        }
        case 3:{
          envio.idEstatus = [1];
          break
        }
        case 4:{
          envio.idEstatus = [2];
          break
        }
        case 5:{
          envio.idEtapa = 67;
          envio.idEstatus = [1,2];
          break
        }
        case 6:{
          envio.idEtapa = 70;
          envio.idEstatus = [1,2];
          break
        }
        case 10:{
          envio.idEtapa = 65;
          envio.idEstatus = [1,2];
          break
        }
        case 8:{
          envio.idEstatus = [1,2];
          break
        }

      }*/


      return envio
    },
    getCifrasPorEstatus() {
      const params = {
        fechaFinal: this.fechaFin,
        fechaIncio: this.fechaInicio,
        idEmpleado: this.idEmpleado,
        idClinica: this.idClinica,
        idPaciente: this.idPaciente
      }
      this.$http
          .post(
              this.$api +
              "pti/bandeja/embajador/cifrasPorEstatusV5", params)
          .then((response) => {
            if (Array.isArray(response.data.data) == true) {
              var data = response.data.data;

              data.forEach((elemento) => {
                if (elemento.idEstatusSolicitud == 89) {
                  this.cifrasControl[0].cantidad = elemento.noTotalSolcitudes;
                  this.cifrasControl[0].layoutTabla = this.encabezadosNegociar;
                }
                if (elemento.idEstatusSolicitud == 90) {
                  this.cifrasControl[1].cantidad = elemento.noTotalSolcitudes;
                  this.cifrasControl[1].layoutTabla = this.encabezadosInversion;
                }
                if (elemento.idEstatusSolicitud == 91) {
                  this.cifrasControl[2].cantidad = elemento.noTotalSolcitudes;
                  this.cifrasControl[2].layoutTabla = this.encabezadosDistribucion;
                }8
              });
            }
            Swal.close();
          })
          .catch((error) => {
            console.error(error);
            Swal.close();
          });
    }, //  ----------------------------

    getObtenerEncargadosClinica() {

      this.$http
          .post(
              this.$api +
              "pti/bandeja/embajador/obtenerEncargadosClinicaPresentacion", this.idClinica
          )
          .then((response) => {
            //NO devuelve un array asi que no funciona validar isArray
            if (Array.isArray(response.data.data) == true) {
              this.resource.arrayDoctorEmbajador = response.data.data;
            }
            Swal.close();
          })
          .catch((error) => {
            console.error(error);
            Swal.close();
          }).finally(() => {
        if (this.nombreTab === undefined || isNaN(this.nombreTab)){
          // this.getObtenerDatosBandeja(1, 1);
          this.getObtenerDatosBandeja(1);
        }else {
          // this.getObtenerDatosBandeja(this.cifrasControl[this.nombreTab].id, this.cifrasControl[this.nombreTab].subtabs[0].id);
          this.getObtenerDatosBandeja(this.cifrasControl[this.nombreTab].id);
        }

      });
    },
    actualizarFecha(fechaInicio, fechaFin, idPaciente) {
      if (fechaFin !== null && fechaInicio !== null) {
        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;
      }
      this.idPaciente = idPaciente === null ? 0 : idPaciente;
      // this.getObtenerDatosBandeja(this.idEstatusPestaniaSeleccionada, this.idEstatusSubTabSeleccionada);
      this.getObtenerDatosBandeja(this.idEstatusPestaniaSeleccionada);
      this.getCifrasPorEstatus();
    },


    showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },

    abrirModalObservaciones(data) {
      this.solicitud = data;
      this.$refs["observaciones"].show();
    },
    abrirModalObservacionesRechazo(data) {
      this.solicitud = data;
      this.$refs["observacionesRechazo"].show();
    },
    abrirModalRechazar(data) {
      this.solicitud = data;
      this.$refs["rechazo"].show();
    },
    cerrarModal(nombre) {
      this.$refs[nombre].hide();
      this.solicitud = null;
      this.motivoRechazo = null;
    },

    postRechazarPTIPresuntivo(idSolicitudDiagnostico) {
      var params = {
        idSolicitudDiagnostico: idSolicitudDiagnostico,
        idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
        motivoRechazo: this.motivoRechazo,
      };

      this.$swal.fire({
        title: "¿Desea rechazar la solicitud?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.loading = true;
          this.$http
              .put(
                  this.$api + "pti/bandeja/embajador/rechazarPTIPresuntivo",
                  params
              )
              .then((response) => {
                if (response.status === 200) {
                  this.$swal.fire({
                    icon: "success",
                    title: "Aviso",
                    text: response.data.message,
                  });
                }
              })
              .catch((error) => {
                console.error(error);
                this.$swal({
                  icon: "error",
                  title: "Ocurrio un error al procesar la solicitud",
                  showConfirmButton: false,
                  timer: 2500,
                });
              })
              .finally(
                  () => (this.loading = false,
                      this.motivoRechazo = null,
                      this.cerrarModal('rechazo'),
                      this.getObtenerDatosBandeja(2, 3))
              );
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });
    },


  },
  mounted() {
    this.getObtenerEncargadosClinica();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.resource = {
      permiteCambiarDiagnosticador: false,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    };
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();

    var dia1 = new Date();
    dia1.setDate(dia1.getDate() - 1);
    dia1.setHours(0, 0, 0, 0);
    this.fechaInicio = this.$moment(dia1).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    var dia2 = new Date();
    dia2.setHours(23, 60, 59, 999);
    this.fechaFin = this.$moment(dia2).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    this.getCifrasPorEstatus();
    this.nombreTab = Number(this.$route.params.tab);


  },
  computed: {},
}
</script>

<style scoped>

</style>